import { render, staticRenderFns } from "./ChangeState.vue?vue&type=template&id=6a207c94&scoped=true&"
import script from "./ChangeState.vue?vue&type=script&lang=js&"
export * from "./ChangeState.vue?vue&type=script&lang=js&"
import style0 from "./ChangeState.vue?vue&type=style&index=0&id=6a207c94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a207c94",
  null
  
)

export default component.exports